import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import classNames from 'classnames';
import {
  I18nProvider,
  EntityMapperContext,
} from '@uncinc/react-drupal-core';

import { Route, Switch } from 'react-router';
import blockMapper from '../../mappers/block';
import nodeMapper from '../../mappers/node';
import paragraphMapper from '../../mappers/paragraphs';
import taxonomyMapper from '../../mappers/taxonomy';
import viewMapper from '../../mappers/view';

import i18next from '../../config/i18next';
import Page from '../Page';

import {
  Breadcrumbs,
} from '../../components';

import Cookie from '../../components/Cookie';

import '../../styles/main.scss';
import './style.scss';
import Navigation from '../../implementations/Navigation';
import Footer from '../../implementations/Footer';
import ApplicationSentScreen from '../ApplicationSent';
import JobApplicationFormScreen from '../JobApplicationForm';
import Entity from '../Entity';
import { APP_ENV, routes } from '../../config/constants';

const entityTypeMapper = {
  block: blockMapper,
  node: nodeMapper,
  paragraph: paragraphMapper,
  taxonomy: taxonomyMapper,
  view: viewMapper,
};

class App extends Component {
  breadcrumbsVisible() {
    const { entityType, entityId, node, taxonomyTerm } = this.props;

    if (entityType === 'node') {
      const nodeType = node.getIn([entityId, 'type', '0', 'target_id']);

      if (
        nodeType === 'text_page'
        || nodeType === 'colleague'
        || nodeType === 'information_page'
      ) {
        return true;
      }
    }

    if (entityType === 'taxonomy_term') {
      const taxonomyType = taxonomyTerm.getIn([entityId, 'vid', '0', 'target_id']);

      if (taxonomyType === 'department') {
        return true;
      }
    }

    return false;
  }

  render() {
    const {
      childEntity,
      rootClasses,
      entityExists,
      language,
    } = this.props;

    const classes = classNames('App', rootClasses.join(' '), {
      'is-front-page': childEntity.get('is_front'),
      'not-found': !entityExists,
    });

    const entityBundle = childEntity.getIn(['type', 0, 'target_id'], '');

    return (
      <EntityMapperContext.Provider value={entityTypeMapper}>
        <I18nProvider locale={language} i18next={i18next}>
          <div className={classes} language={language}>
            <header>
              <Navigation withVacancyNav={entityBundle === 'vacancy'} childEntity={childEntity} />
            </header>
            <main className="main">
              {this.breadcrumbsVisible() && <Breadcrumbs includeCurrent />}
              <Switch>
                <Route exact path={routes.applicationSent}>
                  <ApplicationSentScreen />
                </Route>
                <Route exact path={routes.jobApplicationForm}>
                  <JobApplicationFormScreen />
                </Route>
                <Route>
                  <Entity />
                </Route>
              </Switch>
            </main>
            <footer>
              <Footer />
            </footer>
            {!window.Cypress && (
              <Cookie />
            )}
            <div id="modal-root" />
          </div>
        </I18nProvider>
      </EntityMapperContext.Provider>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const entityType = ownProps.entityType || state.getIn(['entity', 'entityType'], null);
  const entityId = ownProps.entityId || state.getIn(['entity', 'entityId'], null);

  return {
    menus: state.get('menu'),
    node: state.get('node'),
    taxonomyTerm: state.get('taxonomyTerm'),
    maintenanceMode: state.getIn(['ui', 'maintenanceMode']),
    childEntity: ownProps.childEntity || state.getIn([entityType, entityId], Map()),
    path: state.getIn(['router', 'location', 'pathname']),
    rootClasses: state.getIn(['ui', 'rootClasses']),
    entityStatus: state.getIn(['entity', 'status']),
    entityExists: state.getIn(['entity', 'exists']),
    language: state.getIn(['ui', 'language']),
    referenceLoading: state.getIn(['ui', 'referenceLoading']),
    entityType,
    entityId,
  };
}

export default connect(mapStateToProps)((App));

